import React from "react";
import GenerateReport from '../components/GenerateReport';

const Report = () => {
  return (
    <div>
      <GenerateReport />
    </div>
  );
};

export default Report;